import { useContext, useReducer, useEffect, createContext } from "react";
import useFetchData from "./useFetchData.js";
export const ChartDataContext = createContext();
import * as R from "ramda";

export const useChartData = () => useContext(ChartDataContext);

const reducer = (prevState, updatedProperty) => ({
  ...prevState,
  ...updatedProperty,
});

const filterState = { data: [] };

const initState = {
  locationid: ["BAL", "CIN", "DAL", "IND", "MNP"],
  timeframeid: [1, 2, 3],
  indicator: 0,
  subdistributionclass: 0,
  subdistributionid: null,
  subdistributionReadableName: null,
};

export const ChartDataProvider = (props) => {
  const { children, ...otherProps } = props;
  const [chartData, setChartData] = useReducer(reducer, initState);
  const [filterData, setFilterData] = useReducer(reducer, filterState);
  const apiUrl = process.env.GATSBY_DATA_API_URL;
  const { data } = useFetchData(
    //TODO swap with dotenv var
    `${apiUrl}/filters`,
    { method: "GET" },
  );

  useEffect(() => {
    if (data) {
      setFilterData({ data: [...Array.from(R.values(data))] });
    }
  }, [data]);

  return (
    <ChartDataContext.Provider
      value={{ chartData, setChartData, filterData, setFilterData, apiUrl }}
      {...otherProps}
    >
      {children}
    </ChartDataContext.Provider>
  );
};
